// @flow

import { get, _delete } from './shared';

export const getMethods = get(`/:paymentId/experience/methods`);

export const removeTokenisedPaymentMethod = _delete('/:paymentId/experience/tokenized-methods/:tokenId');
